<template>
    <div class="goal-progress" :class="{ 'is-complete': isComplete }">
        <svg class="progress-ring" width="60" height="60">
            <!-- Background circle -->
            <circle
                class="progress-ring__circle-bg"
                stroke="#e6e6e6"
                stroke-width="4"
                fill="transparent"
                r="25"
                cx="30"
                cy="30"
            />
            <!-- Progress circle (shown when not complete) -->
            <circle
                v-if="!isComplete"
                class="progress-ring__circle"
                :stroke="color"
                stroke-width="4"
                fill="transparent"
                r="25"
                cx="30"
                cy="30"
                :stroke-dasharray="157"
                :stroke-dashoffset="157 - (157 * progress) / 100"
            />
            <!-- Success circle and checkmark (shown when complete) -->
            <circle
                v-if="isComplete"
                class="success-circle"
                fill="#34D399"
                r="25"
                cx="30"
                cy="30"
            />
            <path
                v-if="isComplete"
                class="checkmark"
                d="M20 30l7 7 13-13"
                stroke="white"
                stroke-width="3"
                fill="none"
            />
            <!-- Text display (shown when not complete) -->
            <text
                v-if="!isComplete"
                x="30"
                y="25"
                text-anchor="middle"
                dominant-baseline="middle"
                class="progress-ring__text"
            >
                {{ daysRemaining }}
            </text>
            <text
                v-if="!isComplete"
                x="30"
                y="40"
                text-anchor="middle"
                dominant-baseline="middle"
                class="progress-ring__subtext"
            >
                days left
            </text>
        </svg>
    </div>
</template>

<script>
export default {
    name: 'GoalProgressCircle',
    props: {
        progress: {
            type: Number,
            required: true
        },
        daysRemaining: {
            type: Number,
            required: true
        },
        color: {
            type: String,
            required: true
        }
    },
    computed: {
        isComplete() {
            return this.progress >= 100;
        }
    }
};
</script>

<style scoped>
.goal-progress {
    display: inline-flex;
    position: relative;
}

.progress-ring__circle-bg {
    transition: all 0.3s ease;
}

.progress-ring__circle {
    transform-origin: center;
    transform: rotate(-90deg);
    transition: all 0.3s ease;
}

.progress-ring__text {
    font-size: 16px;
    font-weight: 600;
    fill: #374151;
}

.progress-ring__subtext {
    font-size: 10px;
    fill: #6B7280;
}

/* Success state styles */
.is-complete {
    animation: pulse 1.5s infinite;
}

.success-circle {
    transition: all 0.3s ease;
}

.checkmark {
    stroke-dasharray: 100;
    stroke-dashoffset: 100;
    animation: dash 1s ease forwards;
}

@keyframes pulse {
    0% {
        transform: scale(1);
    }
    50% {
        transform: scale(1.20);
    }
    100% {
        transform: scale(1);
    }
}

@keyframes dash {
    to {
        stroke-dashoffset: 0;
    }
}

/* Color transition */
.progress-ring__circle,
.success-circle {
    transition: stroke 0.3s ease, fill 0.3s ease;
}
</style> 